<template>
  <div class="about-container info-html-wrapper">
    <h1 class="title">
      {{ $t('details.trust-and-safety') }}
    </h1>
    <html-loader :url="contentUrl" />
  </div>
</template>

<script>
import DefaultContentPage from './ContentPage/DefaultContentPage';

export default {
  extends: DefaultContentPage,
  data() {
    return {
      pageHandle: 'trust-and-safety',
    };
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/TrustAndSafety.vue